<template>
    <v-container>
        <searchBar @enterSearch="handleSearch"/>
        <searchResults :companiesDisplayed="companiesDisplayed" :addAlias="addAlias" @emitAddAliasEvent="emitAddAliasEvent"/>
    </v-container>
</template>

<script>
import searchBar from '@/components/SearchBar';
import searchResults from '@/components/SearchResults';


export default {
    props: {
        "addAlias": Boolean,
    },
    components: {
        searchBar,
        searchResults,
    },

    data: () => ({
        companiesDisplayed: [],
    }),

    methods: {
        handleSearch(payload) {
            this.companiesDisplayed = payload
        },
        emitAddAliasEvent(payload) {
            console.log("emit event from container");
            this.$emit("emitAddAliasEvent", payload)
        },
    },
}
</script>